<template>
  <div>
    <base-header class="pb-6">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">每日荐股</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <!-- <base-button size="sm" type="neutral">reload</base-button> -->
          <!-- <base-button size="sm" type="neutral">Filters</base-button> -->
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <div>
            <div class="row">
              <div class="col-sm-12">
                <div style="margin-left: 30px">
                  <b-row style="padding-top: 40px">
                   
                    <el-select
                      class="select-primary pagination-select"
                      v-model="strategyType"
                      placeholder="选择策略"
                      style="margin-left: 10px; width: 150px"
                    >
                      <el-option
                        class="select-primary"
                        key=""
                        label="选择策略"
                        value=""
                      >
                      </el-option>
                      <el-option
                        class="select-primary"
                        v-for="item in strategyTypesAry"
                        :key="item.key"
                        :label="item.key != '' ? item.value : '选择策略'"
                        :value="item.key"
                      >
                      </el-option>
                      
                    </el-select>

                    <el-select
                      class="select-primary pagination-select"
                      v-model="level"
                      placeholder="信号级别"
                      style="margin-left: 10px; width: 150px"
                    >
                      <el-option
                        class="select-primary"
                        key=""
                        label="选择信号级别"
                        value=""
                      >
                      </el-option>
                      <el-option
                        class="select-primary"
                        v-for="item in levelsAry"
                        :key="item.key"
                        :label="item.key != '' ? item.value : '选择信号级别'"
                        :value="item.key"
                      >
                      </el-option>
                      
                    </el-select>

                    <base-input
                      style="margin-top: -35px"
                      label="信号K线开始时间"
                    >
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        class="form-control datepicker"
                        style="width: 120px; margin-left: 10px"
                        v-model="search_start"
                      >
                      </flat-picker>
                    </base-input>

                    <base-input style="margin-top: -35px" label="信号K线结束时间">
                      <flat-picker
                        slot-scope="{ focus, blur }"
                        @on-open="focus"
                        @on-close="blur"
                        class="form-control datepicker"
                        style="width: 120px; margin-left: 10px"
                        v-model="search_end"
                      >
                      </flat-picker>
                    </base-input>

                    <base-button
                      style="margin-left: 30px"
                      size="sm"
                      type="neutral"
                      @click="reBuild()"
                      >手工同步K线</base-button
                    >

                    <base-button
                      style="margin-left: 30px"
                      size="sm"
                      type="neutral"
                      @click="reCheck()"
                      >手工检查信号</base-button
                    >
                  </b-row>
                </div>

                <el-table
                  :data="tableData"
                  header-row-class-name="thead-light"
                  style="width: 100%; margin-top: 40px"
                  :row-style="{ height: '80px' }"
                >
                  <el-table-column label="ID" align="left" min-width="100px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row.id }}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="交易对ID" align="left" min-width="100px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row.marketId }}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="交易对Code" align="left" min-width="100px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row.code }}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="交易对" align="left" min-width="100px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row.name }}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="周期" align="left" min-width="100px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row.period }}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="信号K线" align="left" min-width="100px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row.timeId }}</span
                      ><BR/>
                      <span class="table-cell">{{ row.timeId *1000|dateTime1}}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="触发价格" align="left" min-width="100px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row.targetPrice|formatPrice }}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="信号级别" align="left" min-width="100px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{ row.level|formatLevel }}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="策略" align="left" min-width="100px">
                    <template slot-scope="{ row }">
                      <span class="table-cell">{{row.strategyTypeName}}</span
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="计算时间" align="left" min-width="100px">
                    <template slot-scope="{ row }">
                      <span class="table-cell"
                        >{{ row.createdAt | dateTime }} </span
                      ><br />
                    </template>
                  </el-table-column>

                </el-table>
              </div>
              <div
                slot="footer"
                class="
                  col-12
                  d-flex
                  justify-content-center justify-content-sm-between
                  flex-wrap
                "
                style="padding: 20px"
              >
                <div class="">
                  <p
                    class="card-category"
                    style="
                      font-size: 0.8125rem;
                      font-weight: 400;
                      margin-left: 20px;
                    "
                  >
                    第 {{ from + 1 }} - {{ to }} 条，总共 {{ total }} 条
                  </p>
                </div>
                <base-pagination
                  class="pagination-no-border"
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total="total"
                  @change="pagination.currentPage = $event"
                  style="margin-right: 20px"
                >
                </base-pagination>
              </div>
            </div>
            <!-- </card> -->
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>

<script>
var moment = require("moment");
import {
  TimeSelect,
  CheckboxGroup,
  Checkbox,
  Input,
  DatePicker,
  Select,
  Option,
  Scrollbar,
  Table,
  TableColumn,
} from "element-ui";

import stockApi from "../../api/stock";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { extend } from "vee-validate";
import { required, email, min, numeric } from "vee-validate/dist/rules";
import {
  BaseCheckbox,
  BaseRadio,
  BaseProgress,
  RouteBreadCrumb,
  BasePagination,
} from "@/components";
import swal from "sweetalert2";
extend("required", required);
extend("min", min);
extend("numeric", numeric);

export default {
  components: {
    BasePagination,
    flatPicker,
    [Table.name]: Table,
    [Input.name]: Input,
    [TableColumn.name]: TableColumn,
    [TimeSelect.name]: TimeSelect,
    [Select.name]: Select,
    [Option.name]: Option,
    [Scrollbar.name]: Scrollbar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
  },
  filters: {
    dateTime(val) {
      var m = moment(val);
      return m.format("YYYY-MM-DD HH:mm:ss");
    },

    dateTime1(val) {
      var m = moment(val);
      return m.format("YYYY-MM-DD HH:mm:ss");
    },
    formatLevel(val){
      var levels = [
        "不推荐","低","中","高"
      ]
      return levels[val]
    },
   
    formatPrice(val) {
      if (val) {
        return Math.floor(val * 100000000) / 100000000;
      } else {
        return "";
      }
    },
    formatPrice1(val) {
      return Math.round(val * 100 * 100000000) / 100000000;
    },

    toFixed(val) {
      val = val * 100;
      return val.toFixed(2);
    },
    
  },
  watch: {
    "pagination.currentPage": function (val) {
      this.getList();
    },

    strategyType: function (val) {
      this.pagination.currentPage = 1;
      this.reloadData();
    },
    level: function (val) {
      this.pagination.currentPage = 1;
      this.reloadData();
    },
    search_start: function (val) {
      this.pagination.currentPage = 1;
      this.reloadData();
    },
    search_end: function (val) {
      this.pagination.currentPage = 1;
      this.reloadData();
    },
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    // queriedData() {
    // let result = this.tableData;
    // if (this.searchedData.length > 0) {
    //   result = this.searchedData;
    // }
    // return result.slice(this.from, this.to);
    // },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }

      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
      // return this.searchedData.length > 0
      //   ? this.searchedData.length
      //   : this.tableData.length;
    },
  },
  data() {
    return {
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },

      tableData: [],
      periods: {},
      periodsAry: [],

      strategyTypes: {},
      strategyTypesAry: [],
      levelsAry:[],

      markets: [],
      marketId: 10014,
      period: "1min",
      strategyType: "",
      level: "",
      search_start: "",
      search_end: "",
      trigger_type: "",
    };
  },
  created() {
    this.reloadData();
  },
  methods: {

    async reCheck() {
      swal
        .fire({
          title: `确定要手动重新检查信号吗？`,
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-success btn-fill",
            cancelButton: "btn btn-danger btn-fill",
          },
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.doReCheck();
          }
        });


     
    },

    async doReCheck()
    {
      var formData = {};
      const { code } = await stockApi.checkSignal(formData);

      this.$notify({
        message: code == 200?"已开启任务":"开启任务失败",
        timeout: 5000,
        icon: "ni ni-bell-55",
        type: code == 200 ? "success" : "danger",
      });

    },

    async reBuild() {
      swal
        .fire({
          title: `确定要手动重跑Kline吗？`,
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-success btn-fill",
            cancelButton: "btn btn-danger btn-fill",
          },
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.doReBuild();
          }
        });


     
    },

    async doReBuild()
    {
      var formData = {};
      const { code } = await stockApi.synckLines(formData);

      this.$notify({
        message: code == 200?"已开启任务":"开启任务失败",
        timeout: 5000,
        icon: "ni ni-bell-55",
        type: code == 200 ? "success" : "danger",
      });

    },
    
    getDealConfig(id) {
      // console.log("getDealConfig:", id);
      for (var i = 0; i < this.dealConfigs.length; i++) {
        if (this.dealConfigs[i].id == id) {
          return this.dealConfigs[i];
        }
      }

      return false;
    },
    reloadData() {
      this.getList();
    },

    

    async getList() {
      var formData = {
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.perPage,
      };


      if (this.strategyType != "") {
        formData.strategyType = this.strategyType;
      }

      if (this.level != "") {
        formData.level = this.level;
      }
      if (this.search_start != "") {
        formData.search_start = this.search_start;
      }
      if (this.search_end != "") {
        formData.search_end = this.search_end;
      }

      const { code, data } = await stockApi.recommendList(formData);

      if (code != 200) {
        return;
      }

      const { list, total, strategyTypes } = data;

      console.log("-=---strategyTypes:", strategyTypes);

      //   this.periods = periods;
      this.strategyTypes = strategyTypes;
      this.tableData = list;

      //   let periodsAry = [];
      //   for (let key in periods) {
      //     periodsAry.push({ key, value: periods[key] });
      //   }
      //   this.periodsAry = periodsAry;

      let strategyTypesAry = [];
      for (let key in strategyTypes) {
        strategyTypesAry.push({ key, value: strategyTypes[key] });
      }
      this.strategyTypesAry = strategyTypesAry;

      this.levelsAry = [
        {key:1,value:"低"},
        {key:2,value:"中"},
        {key:3,value:"高"}
      ]

      this.pagination.total = total;
    },
  },
};
</script>

<style lang="scss" scoped>
.cardMadal .card-body {
  padding: 40px 0 0 35px !important;
}
</style>